import { create } from "zustand";
import {
  Partner,
  PartnerResource,
  CreatePartnerRequest,
  UpdatePartnerRequest,
} from "../api/partners";

interface PartnersState {
  partners: Partner[];
  loading: boolean;
  error: string | null;
  loadPartners: () => Promise<void>;
  createPartner: (data: CreatePartnerRequest) => Promise<Partner>;
  updatePartner: (
    partnerId: string,
    data: UpdatePartnerRequest
  ) => Promise<Partner>;
}

export const usePartnersStore = create<PartnersState>((set) => ({
  partners: [],
  loading: false,
  error: null,

  loadPartners: async () => {
    set({ loading: true, error: null });
    try {
      const partners = await PartnerResource.getList();
      set({ partners, loading: false });
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : "Failed to load partners",
        loading: false,
      });
    }
  },

  createPartner: async (data) => {
    const partner = await PartnerResource.create(data);
    set((state) => ({ partners: [...state.partners, partner] }));
    return partner;
  },

  updatePartner: async (partnerId, data) => {
    const updated = await PartnerResource.update(partnerId, data);
    set((state) => ({
      partners: state.partners.map((p) => (p.id === partnerId ? updated : p)),
    }));
    return updated;
  },
}));
